import { render, staticRenderFns } from "./FeatureUnavailable.vue?vue&type=template&id=09bd789e&scoped=true"
import script from "./FeatureUnavailable.vue?vue&type=script&lang=js"
export * from "./FeatureUnavailable.vue?vue&type=script&lang=js"
import style0 from "./FeatureUnavailable.vue?vue&type=style&index=0&id=09bd789e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd789e",
  null
  
)

export default component.exports